import type React from "react";

export const AlertBanner: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className="bg-error-solid px-4 py-3 text-center text-sm font-medium text-white">
    <p className="mx-auto max-w-4xl text-balance">{children}</p>
  </div>
);
